import GroupingsIndex from '@/views/groupings/index';
import GroupingsShow from '@/views/groupings/show';

export default [
  {
    path: '/groupings/:categoryId?',
    name: 'groupings#index',
    component: GroupingsIndex,
    meta: {
      header: true,
    },
  },
  {
    path: '/groupings/:categoryId?/:groupingId/:assetAssociationId?',
    name: 'groupings#show',
    component: GroupingsShow,
    meta: {
      masteryHeader: true,
    },
  },
];